import { useMutation, UseMutationOptions } from 'react-query';

import { CreditApi, CreditsRefillStatusPayload } from 'api/CreditApi';

export const useCreditsRefillStatusMutation = (
  options?: UseMutationOptions<
    { enabled: boolean },
    unknown,
    CreditsRefillStatusPayload,
    unknown
  >
) => {
  return useMutation(CreditApi.updateCreditsRefillStatus, options);
};
